import { Box, List, ListItem, ListItemText, ListItemButton } from '@mui/material';
import { formatShortFriendlyDateWithTime } from '../../../../helpers';
import { IPunchlistItemCommentFile, IPunchlistTodoItemFile } from '../../../../models';
import { FC } from 'react';

interface ITodoItemUploadsList {
  files: IPunchlistTodoItemFile[] | IPunchlistItemCommentFile[];
  setSelectedImage: (val: string) => void;
  setSelectedPdf: (val: string) => void;
}

export const TodoItemUploadsList: FC<ITodoItemUploadsList> = ({
  files,
  setSelectedImage,
  setSelectedPdf
}) => {
  return (
    <>
      {files?.length > 0 && (
        <>
          <Box>
            <List disablePadding>
              {files.map((file: any, fileIndex) => {
                return (
                  <ListItem disablePadding key={`${fileIndex}`}>
                    <ListItemButton
                      sx={theme => ({
                        color: theme.palette.primary.main
                      })}
                      onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (
                          file.fileUrl.includes('.jpg') ||
                          file.fileUrl.includes('.png') ||
                          file.fileUrl.includes('.jpeg')
                        ) {
                          return setSelectedImage(file.fileUrl);
                        }
                        if (file.fileUrl.includes('.pdf')) {
                          return setSelectedPdf(file.fileUrl);
                        }
                      }}
                    >
                      <ListItemText
                        primary={file.fileName ?? file.originalFileName}
                        secondary={`Upload Date: ${formatShortFriendlyDateWithTime(
                          file.createdOn
                        )}`}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </>
      )}
    </>
  );
};
